module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/4_870236c15954ab685d345e149d06d57e.png";